import styled from "styled-components";
import Select from "../../../../../../inputs/select/index.js";
import personCounterSelectThemes from "./themes/index.js";
export const PersonCounterSelectWrapper = styled.div.withConfig({
    displayName: "styled__PersonCounterSelectWrapper",
    componentId: "sc-511ac2e4-0"
})`
	${({ $columns =2  })=>`flex-basis: calc(calc(100% / ${$columns}) - (12px / ${$columns} * ${$columns - 1}));`}
	border: 1px solid ${({ theme  })=>theme.colors.grays.light};
	border-radius: ${({ theme  })=>theme.border.radius.rounded};

	.input-without-label {
		padding: 0 42px 0 16px;
		min-height: 38px;
	}

	.icon-without-label {
		font-size: 15px;
	}
	${({ theme  })=>personCounterSelectThemes[theme.id]?.PersonCounterSelectWrapper?.()};
`;
export const AgeSelect = styled(Select).withConfig({
    displayName: "styled__AgeSelect",
    componentId: "sc-511ac2e4-1"
})`
	${({ theme  })=>personCounterSelectThemes[theme.id]?.AgeSelect?.()};
`;

//# sourceMappingURL=styled.js.map